<div id="card-container">
  <div class="card-section">
    <div class="card-title">
      You have been logged out of the Account Manager Portal
    </div>
    <!-- <div class="card-content">
      <button class="adb2c-loginbutton" (click)="userAuth()">Login</button>
    </div> -->
  </div>
</div>
